import React from "react";

/** Full-width stats strip. Edge-to-edge, no boxed max-width. */
const StatsBar = ({ stats = [] }) => {
  if (!stats.length) return null;

  return (
    <section
      className="relative w-full border-y border-[color:var(--card-border)]"
      style={{
        backgroundColor: "color-mix(in oklab, var(--violet) 8%, var(--card))",
      }}
      data-testid="stats-bar"
    >
      <div
        className="grid text-center"
        style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}
      >
        {stats.map((s, i) => (
          <div
            key={s.label + i}
            className={`py-6 md:py-8 px-3 md:px-6 ${
              i > 0 ? "border-l border-[color:var(--card-border)]" : ""
            }`}
          >
            <div className="font-display font-semibold text-2xl md:text-4xl leading-none text-[color:var(--violet)]">
              {s.value}
            </div>
            <div className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.18em] text-[color:var(--muted)] leading-tight">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBar;
